export default __webpack_public_path__ + "static/media/m1-garand.b8d9e705.svg";